import { render, staticRenderFns } from "./sub-visual.vue?vue&type=template&id=704c2646&scoped=true&"
import script from "./sub-visual.vue?vue&type=script&lang=js&"
export * from "./sub-visual.vue?vue&type=script&lang=js&"
import style0 from "./sub-visual.vue?vue&type=style&index=0&id=704c2646&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704c2646",
  null
  
)

export default component.exports